import {useCallback, useEffect, useRef, useState} from "react";

import {useElementWasVisible} from "@pg-mono/hooks";

import {IOfferListOffer} from "../../../offer/types/IOfferListOffer";
import {trackPricesHubOffersViewItemList} from "../tracking/track_prices_hub_offers_view_item_list";

interface IUsePricesHubOffersViewItemListTrackingParams {
    offers: IOfferListOffer[];
    itemListId?: string;
    /** While the city filter is still loading, the offers on screen belong to the previous filter. */
    isFetching: boolean;
}

const CAROUSEL_VISIBILITY_THRESHOLD = 0.5;
const CAROUSEL_ELEMENT_ID = "prices-hub-offers-carousel";

export const usePricesHubOffersViewItemListTracking = (params: IUsePricesHubOffersViewItemListTrackingParams) => {
    const {offers, itemListId, isFetching} = params;
    const carouselRef = useRef<HTMLDivElement | null>(null);
    const trackedContextKeyRef = useRef<string | null>(null);
    const [wasCarouselVisible, setWasCarouselVisible] = useState(false);
    const offerIds = offers.map(({id}) => id).join(",");

    // the observer keeps the callback it was mounted with, so visibility only flips state - the effect below reads the current offers
    const handleCarouselVisible = useCallback(() => setWasCarouselVisible(true), []);

    useElementWasVisible({
        ids: [],
        elementRefs: [{id: CAROUSEL_ELEMENT_ID, ref: carouselRef}],
        onElementVisible: handleCarouselVisible,
        once: true,
        threshold: CAROUSEL_VISIBILITY_THRESHOLD
    });

    useEffect(() => {
        if (!wasCarouselVisible || isFetching || offers.length === 0) {
            return;
        }

        const contextKey = `${itemListId ?? ""}|${offerIds}`;

        if (trackedContextKeyRef.current === contextKey) {
            return;
        }

        trackedContextKeyRef.current = contextKey;
        trackPricesHubOffersViewItemList({offers, itemListId});
    }, [wasCarouselVisible, isFetching, itemListId, offerIds, offers]);

    return carouselRef;
};
import {useCallback, useEffect, useRef, useState} from "react";

import {useElementWasVisible} from "@pg-mono/hooks";

import {IOfferListOffer} from "../../../offer/types/IOfferListOffer";
import {trackPricesHubOffersViewItemList} from "../tracking/track_prices_hub_offers_view_item_list";

interface IUsePricesHubOffersViewItemListTrackingParams {
    offers: IOfferListOffer[];
    itemListId?: string;
    /** While the city filter is still loading, the offers on screen belong to the previous filter. */
    isFetching: boolean;
}

const CAROUSEL_VISIBILITY_THRESHOLD = 0.5;
const CAROUSEL_ELEMENT_ID = "prices-hub-offers-carousel";

export const usePricesHubOffersViewItemListTracking = (params: IUsePricesHubOffersViewItemListTrackingParams) => {
    const {offers, itemListId, isFetching} = params;
    const carouselRef = useRef<HTMLDivElement | null>(null);
    const trackedContextKeyRef = useRef<string | null>(null);
    const [wasCarouselVisible, setWasCarouselVisible] = useState(false);
    const offerIds = offers.map(({id}) => id).join(",");

    // the observer keeps the callback it was mounted with, so visibility only flips state - the effect below reads the current offers
    const handleCarouselVisible = useCallback(() => setWasCarouselVisible(true), []);

    useElementWasVisible({
        ids: [],
        elementRefs: [{id: CAROUSEL_ELEMENT_ID, ref: carouselRef}],
        onElementVisible: handleCarouselVisible,
        once: true,
        threshold: CAROUSEL_VISIBILITY_THRESHOLD
    });

    useEffect(() => {
        if (!wasCarouselVisible || isFetching || offers.length === 0) {
            return;
        }

        const contextKey = `${itemListId ?? ""}|${offerIds}`;

        if (trackedContextKeyRef.current === contextKey) {
            return;
        }

        trackedContextKeyRef.current = contextKey;
        trackPricesHubOffersViewItemList({offers, itemListId});
    }, [wasCarouselVisible, isFetching, itemListId, offerIds, offers]);

    return carouselRef;
};
